import React from 'react'
import { Outlet } from 'react-router-dom'
import { Icon, NavBar } from '../../../components'
import { IconEvents } from '../components'
import '../index.css'

const App = ({ appName }) => {

  const links = [
    // Hem is the list itself, so there is no separate "Lista" entry — it would
    // be a second link to the same page.
    {
      type: "link",
      relativePath: "",
      label: "Hem",
      icon: <Icon name="home" />,
    },
    {
      type: "section",
      label: "Vyer",
      links: [
        {
          type: "link",
          relativePath: "calendar",
          label: "Kalender",
          icon: <IconEvents name="calendar" />,
        },
      ],
    },
  ]

  return (
    <div className={"app-container" + (appName ? " " + appName : "")}>

      <NavBar links={links} appName={appName} />

      <div className="app-content">
        <Outlet context={appName} />
      </div>

    </div>
  )
}

export default App
